export function transformImageUrl(image, transforms) {
    if (image.mimeType === "image/svg+xml") {
        return image.url;
    }
    let _transforms = [];
    if (transforms.width) {
        _transforms.push(`w_${transforms.width}`);
    }
    if (transforms.height) {
        _transforms.push(`h_${transforms.height}`);
    }
    if (transforms.fit) {
        _transforms.push(`f_${transforms.fit}`);
    }
    if (image.gravity) {
        _transforms.push(`g_${image.gravity}`);
    }
    const parts = image.url.split("/");
    parts.splice(parts.length - 1, 0, _transforms.join(","));
    return parts.join("/");
}
